import { render, staticRenderFns } from "./ContactRelationFillter.vue?vue&type=template&id=0c88afdd&"
import script from "./ContactRelationFillter.vue?vue&type=script&lang=js&"
export * from "./ContactRelationFillter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports